import React, {Component} from "react";

const types = {
    'eic': 1,
    'id': 2
};

export default class CheckApplication extends Component {
    constructor() {
        super(...arguments);

        this.state = {
            type: 1,
            inputValue: '',
            status: null,
            failMessage: null
        }

        this.check = this.check.bind(this);
    }

    check() {
        axios.get('/gas/check-status', {
            params: {
                type: this.state.type,
                identifier: this.state.inputValue,
            }
        })
            .then((resp) => {
                this.setState({
                    status: resp.data.status_name,
                    failMessage: ''
                });
            })
            .catch((error) => {
                this.setState({
                    status: '',
                    failMessage: error.response.data.message || window.translates.check.request_error
                });
            })
    }

    render() {
        const {type, inputValue, status, failMessage} = this.state;

        return (
            <div className="check-application-wrapper">
                <div className="header my-3">
                    <h1>{window.translates.check.title}</h1>
                </div>
                <div className="info my-3">
                    <p>{window.translates.check.eic_info}</p>
                </div>
                <div className="input">
                    <div className="d-flex justify-content-center mb-4">
                        <button className={`btn btn-site ${type === types.eic ? 'btn-dark' : 'btn-outline-dark'}`}
                                onClick={() => this.setState({type: types.eic})}
                        >
                            {window.translates.check.check_types.eic}
                        </button>
                        <button className={`ml-3 btn btn-site ${type === types.id ? 'btn-dark' : 'btn-outline-dark'}`}
                                onClick={() => this.setState({type: types.id})}
                        >
                            {window.translates.check.check_types.id}
                        </button>
                    </div>
                    <div className="form-group">
                        <input type="text"
                               className="form-control"
                               value={inputValue}
                               placeholder={type === types.eic ? window.translates.placeholders.eic : window.translates.placeholders.application_id}
                               onChange={(e) => this.setState({inputValue: e.target.value})}
                        />
                    </div>
                    <div className="text-center my-4">
                        <button className="btn btn-site btn-dark mb-4"
                                onClick={this.check} disabled={!inputValue}
                        >
                            {window.translates.check.check_button}
                        </button>
                        {status &&
                        <div className="alert alert-success">
                            {window.translates.check.status}: <b>{status}</b>
                        </div>
                        }
                        {failMessage &&
                        <div className="alert alert-danger">
                            {failMessage}
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
